import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProviderStore, RootStoreInstance } from '@stores';
import MainPage from '@pages/MainPage';
import { AddressPageInfo } from '@pages/AddressPageInfo';
import AirQualityPage from '@pages/AirQualityPage';
import GoldenBeePage from '@pages/GoldenBeePage';
import { RPC_URL } from '@constants/system';
import { ThemeProvider } from '@mui/material/styles';
import theme from '@constants/theme';
import AddressRoute from './NavigationStack/AddressRoute';

const App = () => {
  useEffect(() => {
    RootStoreInstance.configAnonymousClient(RPC_URL);
  }, []);

  return (
    <ProviderStore value={RootStoreInstance}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainPage />} exact />
            <Route exact path="/address/:id" element={<AddressPageInfo />} />
            <Route exact path="/address/:id/dev" element={<AddressRoute isDevelop />} />
            <Route exact path="/address/:id/*" element={<AddressRoute />} />
            <Route exact path="/air-quality" element={<AirQualityPage />} />
            <Route exact path="/golden-bee" element={<GoldenBeePage />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ProviderStore>
  );
};

export default App;
